<template>
  <section class="table-sampler-validation-noise">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Amostra representativa</label>
        <select type="text" class="form-control" v-model="model.exposition" required>
          <option value="Sim" selected>Sim</option>
          <option value="Não">Não</option>
        </select>
      </d-col>
      <d-col cols="9">
        <label>Avaliação pessoal do trabalhador sobre exposição</label>
        <autocomplete
          ref="autocomplete_avaliation"
          placeholder="Avaliação"
          :items="getAutocompleteItems('avaliation')"
          item-show="name"
          :on-input="(name) => getList('avaliation', name)"
          :on-select="(item) => setData('avaliation', item)"
          :showMessageNotFound="false"
          showIconClear
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Tipo de exposição</label>
        <select type="text" class="form-control" v-model="model.exposition_type" required>
          <option value="Abaixo do normal" selected>Abaixo do normal</option>
          <option value="Normal">Normal</option>
          <option value="Acima do normal">Acima do normal</option>
        </select>
      </d-col>
      <d-col cols="9">
        <label>Justifique</label>
        <autocomplete
          ref="autocomplete_justify"
          placeholder="Justifique"
          :items="getAutocompleteItems('justify')"
          item-show="name"
          :on-input="(name) => getList('justify', name)"
          :on-select="(item) => setData('justify', item)"
          :showMessageNotFound="false"
          showIconClear
          required
        />
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, filterNullNames } from '_utils';
import Autocomplete from '_shared/Autocomplete.vue';
import { NOISE_VALIDATION, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Validation-Noise',
  props: {
    validation: {
      type: Object,
      default: null,
    },
  },
  components: {
    Autocomplete,
  },
  data() {
    return {
      model: cloneDeep(NOISE_VALIDATION),
      optionsOriginal: {},
      options: {},
    };
  },
  computed: {
    noiseSettings() {
      const { noise } = this.$store.state.settings.validation || {};
      if (noise) {
        return noise;
      }
      return { ...NOISE_VALIDATION };
    },
  },
  methods: {
    ...mapActions(['getSettings']),
    getAutocompleteItems(type) {
      return this.options?.[type] || [];
    },
    setData(type, data) {
      if (!data && this.optionsOriginal?.[type]) {
        this.options = {
          ...this.options,
          [type]: [...this.optionsOriginal[type]],
        };
      }

      if (this.model) {
        this.model[type] = data?.name || null;
      }
    },
    getList(type, name = null) {
      this.model[type] = name;
      const baseOptions = this.optionsOriginal[type] || [];
      let filtered = [...baseOptions];
      if (name) {
        const filterValue = name.trim().toLowerCase();
        filtered = baseOptions.filter(item =>
          item?.name?.toLowerCase().includes(filterValue));
      }
      this.options = {
        ...this.options,
        [type]: filtered,
      };
    },
    initializeAutocompleteOptions(filteredData) {
      const avaliationOptions = filteredData.avaliation || [];
      const justifyOptions = filteredData.justify || [];
      this.optionsOriginal = {
        avaliation: [...avaliationOptions],
        justify: [...justifyOptions],
      };
      this.options = { ...this.optionsOriginal };
    },
    insertAutocompleteValues() {
      if (this.model.avaliation) {
        this.setAutocompleteValue('autocomplete_avaliation', this.model.avaliation);
      }

      if (this.model.justify) {
        this.setAutocompleteValue('autocomplete_justify', this.model.justify);
      }
    },
    setAutocompleteValue(refName, value) {
      const ref = this.$refs[refName];
      if (ref && value) {
        ref.$refs.input.value = value;
      }
    },
    setModel() {
      if (this.validation) {
        this.model = cloneDeep(this.validation);
      }

      const filteredData = filterNullNames(this.noiseSettings.options || {});

      this.initializeAutocompleteOptions(filteredData);

      this.$nextTick(() => {
        this.insertAutocompleteValues();
      });
    },
    prepareSettings() {
      const hasNoise = this.noiseSettings && Object.keys(this.noiseSettings).length > 0;

      if (!hasNoise) {
        this.getSettings().then(() => this.setModel());
      } else {
        this.setModel();
      }
    },
  },
  mounted() {
    this.prepareSettings();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:validation', value);
      },
      deep: true,
    },
    noiseSettings: {
      handler() {
        this.setModel();
      },
      deep: true,
    },
  },
};
</script>
